import hero from "../../assets/lightbox/frames/hero.webp";
import sherlocked from "../../assets/lightbox/frames/sherlocked.webp";
import whiteLotus from "../../assets/lightbox/frames/white-lotus.webp";
import weekendAtBernies from "../../assets/lightbox/frames/weekend-at-bernies.webp";

/* UI-DESIGN: LB-16 phones (768 px and under) get pre-rendered frames of the
   same scene instead of live WebGL: the portrait framing of the hero and of
   each case chapter, rendered from StoryScene and saved as webp (12 to 23
   KB each). Re-render them when the scene or the case art changes (see
   docs/lightbox/STORY.md). Cases without a frame fall back to the CSS
   slide mount. */
const FRAME_BY_KEY: Record<string, string> = {
  sherlocked,
  whitelotus: whiteLotus,
  weekendatbernies: weekendAtBernies,
};

const keyOf = (name: string) => name.toLowerCase().replace(/[^a-z0-9]/g, "");

export const heroFrame = hero;

export const frameFor = (name: string | undefined): string | null =>
  (name && FRAME_BY_KEY[keyOf(name)]) || null;
